<ngx-messaging-channel
  [channelByParams]="channelByPhone"
  [channelUID]="channelUID"
  [canUseCache]="canUseCache"
  [workspace]="workspace"
  [dealerSettings]="dealerSettings"
  [displayName]="displayName"
  [messagesStartDate]="messagesStartDate"
  (linkClicked)="handleLinkClick($event)"
  (orderIdEvent)="emitOrderIdEvent($event)"></ngx-messaging-channel>
